<template>
  <div class="score-histogram">
    <bar-chart v-if="chartData" :chart-data="chartData" :options="chartOptions" :height="300" />
    <p v-else>Loading score distribution...</p>
  </div>
</template>

<script lang="ts">
import { Bar } from 'vue-chartjs';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    BarChart: {
      extends: Bar,
      props: {
        chartData: Object,
        options: Object,
      },
      mounted() {
        // @ts-ignore
        this.renderChart(this.chartData, this.options);
      },
      watch: {
        chartData() {
          // @ts-ignore
          this.$data._chart.destroy();
          // @ts-ignore
          this.renderChart(this.chartData, this.options);
        },
      },
    },
  },
})
export default class ScoreHistogram extends Vue {
  @Prop({ type: Array, required: true }) readonly distribution!: number[];
  @Prop({ type: Number, default: 100 }) readonly bucketSize!: number;

  chartData: any = null;
  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Score Range',
          },
        },
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Number of Users',
          },
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        title: (tooltipItems: any) => {
          const index = tooltipItems[0].index;
          const min = index * this.bucketSize;
          const max = (index + 1) * this.bucketSize - 1;
          return `Score: ${min} - ${max}`;
        },
        label: (tooltipItem: any) => {
          return `Users: ${tooltipItem.value}`;
        },
      },
    },
  };

  @Watch('distribution', { immediate: true })
  onDistributionChange() {
    this.updateChartData();
  }

  @Watch('bucketSize', { immediate: true })
  onBucketSizeChange() {
    this.updateChartData();
  }

  updateChartData() {
    // Don't update chart data if distribution is empty
    if (!this.distribution || this.distribution.length === 0) {
      this.chartData = null;
      return;
    }

    // Create labels based on bucket size
    const labels = this.distribution.map((_, index) => {
      const min = index * this.bucketSize;
      const max = (index + 1) * this.bucketSize - 1;
      return `${min}-${max}`;
    });

    // Update chart data with new distribution and labels
    this.chartData = {
      labels,
      datasets: [
        {
          label: 'User Score Distribution',
          backgroundColor: '#e79517',
          data: this.distribution,
        },
      ],
    };
  }
}
</script>

<style lang="scss" scoped>
.score-histogram {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  max-width: 800px;
}
</style>
